import React from 'react';


import {BasicPage} from 'src/components/basic-page';
import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group, Item} from '@pb/kit-component-group';


import {SECTION_NAME} from './constants';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const FullStoryConfiguratorSkeleton: React.FC<Props> = ({children: _children, ...rest}) => {
    const dataSkeleton = (rest as Record<string, unknown>)['data-skeleton'];

    return (
        <BasicPage
            {...rest}
            role={rest.role ?? 'skeleton'}
            data-skeleton={dataSkeleton ?? true}
            title={SECTION_NAME}
            buttonsBlock={(
                <Group>
                    <SkeletonItem width={134} height={32}/>
                    <SkeletonItem width={116} height={32}/>
                </Group>
            )}>
            <Group className="pd-l">
                <Group direction="v" alignItems="start">
                    <Group alignItems="center">
                        <Item style={{width: 300}}>
                            <SkeletonItem width={115} height={18}/>
                        </Item>
                        <Group alignItems="center">
                            <SkeletonItem width={70} height={32}/>
                            <SkeletonItem width={10} height={16}/>
                        </Group>
                    </Group>
                    <Group>
                        <Item style={{width: 300}}>
                            <SkeletonItem width={124} height={18}/>
                        </Item>
                        <Group alignItems="center">
                            <SkeletonItem width={70} height={32}/>
                            <SkeletonItem width={150} height={32}/>
                        </Group>
                    </Group>
                    <FormItemSkeleton labelWidth={72}>
                        <SkeletonItem width={600} height={40}/>
                    </FormItemSkeleton>
                    <FormItemSkeleton labelWidth={78}>
                        <SkeletonItem width={600} height={40}/>
                    </FormItemSkeleton>
                </Group>
            </Group>
        </BasicPage>
    );
};
